import axios from 'axios';
import { Auth } from 'aws-amplify';

const isTestBuild = process.env.NODE_ENV === 'test';

if (isTestBuild) {
  axios.defaults.baseURL = 'http://localhost/api';
} else {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}

axios.interceptors.request.use(
  (config) => {
    return Auth.currentAuthenticatedUser().then((user) => {
      const token = user.signInUserSession.idToken['jwtToken'];
      if (token) {
        config.headers.Authorization = `${token}`;
      }

      return config;
    });
  },
  (err) => {
    return Promise.reject(err);
  }
);

export { axios as API };
